import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

import SVG from '../../SVG/SVG'

const useStyles = createUseStyles(theme => ({
    bookingSearchButton: {
        background: theme.colors.sunshine,
        borderRadius: theme.borderRadius,
        borderStyle: 'none',
        borderWidth: 0,
        cursor: 'pointer',
        // color: theme.colors.marine,
        color: theme.colors.blue,
        display: 'block',
        fontFamily: theme.fontFamily,
        fontSize: 12,
        fontWeight: 'bold',
        letterSpacing: '0.38px',
        lineHeight: 'normal',
        marginBottom: 0,
        // marginLeft: 0,
        // marginRight: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 15,
        paddingBottom: 15,
        paddingTop: 13,
        paddingLeft: 19,
        paddingRight: 19,
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: `background-color ${theme.animations.animate}, color ${theme.animations.animate}`,
        minWidth: 120,
        minHeight: 110,

        '&:hover': {
            backgroundColor: theme.colors.sunflower,
        },

        '&.disabled': {
            backgroundColor: theme.colors.warmGrey,
            color: theme.colors.darkergrey,
        },

        '& span': {
            display: 'block',
            width: '100%',
            textAlign: 'center',
        },

        // "@media (max-width: 1200px)": {
        '@media (max-width: 1400px)': {
            alignItems: 'center',
            display: 'flex',
            paddingBottom: 7,
            paddingTop: 7,
            margin: '44px 0 0',
            paddingLeft: 30,
            paddingRight: 30,
            minWidth: 'unset',
            minHeight: 'unset',
            '& span': {
                width: 'auto',
            },
            '@media (max-width: 900px)': {
                margin: '44px auto 20px',
            },
        },
    },
    svg: {
        '& svg': {
            // marginBottom: 12,
            // height: 28,
            // width: 26,
            marginBottom: 0,
            height: 50,
            width: 'auto',
        },
        '&.disabled svg path': {
            fill: `${theme.colors.darkergrey}`,
        },
        // "@media (max-width: 1200px)": {
        '@media (max-width: 1400px)': {
            '& svg': {
                marginBottom: 0,
                height: 18,
                width: 16,
                marginRight: 5,
            },
        },
    },
    bookingTitle: {
        ...theme.headings.BookingSearchButtonHeading,
        color: theme.colors.white,
        margin: 0,
        paddingBottom: 17,
        paddingTop: 19,
    },
}))

// const BookingSearchButton = ({
//   children,
//   onClick
// }) => {
const BookingSearchButton = props => {
    const classes = useStyles()
    return (
        <button
            onClick={() => props.onClick()}
            className={`${classes.bookingSearchButton} ${props.disabled ? 'disabled' : ''}`}
            disabled={props.disabled}
        >
            <span className={`${classes.svg} ${props.disabled ? 'disabled' : ''}`}>
                <SVG name={'SearchCar'} width={26} height={28} colorOne={'#01396C'} />
            </span>
            <span className={classes.text}>{props.children}</span>
        </button>
    )
}

/* If you don't provide onclick the component will throw an illegible error
that has to do with the way webpack works, if you need a button with no
onclick, you will need to make sure to alter this component a little. */

// BookingSearchButton.propTypes = {
//   children: PropTypes.oneOfType([
//     PropTypes.string,
//     PropTypes.node,
//   ]),
//   onClick: PropTypes.func.isRequired
// }

export default BookingSearchButton
